import { RouteObject } from '@/routers/interFace';
import React from 'react';
import { Index } from '@/views/index/Index';

export default [
  {
    path: '/index',
    element: <Index />
  }
] as RouteObject[];
